import { useNavigate } from 'react-router-dom';
import { OysterLogo } from '@oysterjs/ui/logo';
import { PrimaryButton } from '@oysterjs/ui/button';
import { signOut } from '~/api/data/users/mutations';

/**
 * The whole web app for an account the smart_fill_extension_only gate confines to
 * the browser extension. The API refuses everything else for such an account, so
 * this page only explains that and offers a way out.
 */
export const SmartFillOnlyPage = () => {
  const navigate = useNavigate();

  const onSignOut = async () => {
    const { data, error } = await signOut();
    if (!error && data?.agencySignOut) {
      navigate('/app/signin');
    }
  };

  return (
    <div className="w-full min-h-screen bg-neutral-50 dark:bg-neutral-900 pt-12 sm:pt-24">
      <div className="sm:bg-white dark:sm:bg-neutral-800 sm:rounded-lg sm:shadow max-w-md m-auto flex flex-col items-center px-6 py-12 lg:px-8 text-center">
        <OysterLogo className="flex justify-center" />
        <h2 className="mt-10 text-2xl/9 font-medium tracking-tight text-neutral-900 dark:text-white">
          This account is for Cara Smart Fill
        </h2>
        <p className="mt-4 text-sm/6 text-neutral-600 dark:text-neutral-300">
          Open Cara Smart Fill from your browser&apos;s toolbar to fill forms. The rest of Cara
          isn&apos;t available to this account.
        </p>
        <PrimaryButton className="mt-8" onClick={() => void onSignOut()}>
          Sign out
        </PrimaryButton>
      </div>
    </div>
  );
};
